<template lang="html">
  <div class="slide">
    <svg class="canvas" :viewBox="`0 0 ${canvasWidth} ${canvasHeight}`" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <clipPath id="clipFrame">
          <rect x="0" y="0" :width="canvasWidth" :height="canvasHeight" />
        </clipPath>
        <filter id="hue1">
          <feColorMatrix id="hue1feColorMatrix" in="SourceGraphic" type="hueRotate" values="0"/>
        </filter>
      </defs>
      <rect id="Frame" x="0" y="0" :width="canvasWidth" :height="canvasHeight" />
      <g ref="scene">
        <g filter="url(#hue1)" ref="sky">
          <ImageLazy width="4175" height="1325" :srcs="[
            `${publicPath}scenes/john-austin/Sky-q80-w1000.png`,
            `${publicPath}scenes/john-austin/Sky.png`
          ]"/>
        </g>
        <image ref="sun" width="1908" height="1930" x="984" y="126" :xlink:href="`${publicPath}scenes/john-austin/JohnAustin2.png`"/>
        <foreignObject x="0" y="519" width="4175" height="2487">
          <picture>
            <source :srcset="`${publicPath}scenes/john-austin/Main-480w.png`" media="(max-width: 480px)">
            <source :srcset="`${publicPath}scenes/john-austin/Main-768w.png`" media="(max-width: 768px)">
            <source :srcset="`${publicPath}scenes/john-austin/Main-1280w.png`" media="(max-width: 1280px)">
            <source :srcset="`${publicPath}scenes/john-austin/Main-1920w.png`" media="(max-width: 1920px)">
            <img :style="{width: `100%`, height: `auto`}" :src="`${publicPath}scenes/john-austin/Main.png`" />
          </picture>
        </foreignObject>
        <image width="4175" height="2484" x="0" y="522" :xlink:href="`${publicPath}scenes/john-austin/JohnAustin4.png`"/>
      </g>
    </svg>
    <SceneDialogue
      ref="d1"
      :width=".22" :tx="0" :ty=".7">
      One day, on his way back from the trading post, Grandpa Jim stopped in Tsegi Canyon to see his old friend, John Austin.
    </SceneDialogue>
    <SceneDialogue
      ref="d2"
      :width=".22" :tx="1" :ty=".45">
      When Grandpa Jim went home, he told his sons John Austin needed a husband for his daughter, Gertie.
    </SceneDialogue>
    <SceneAudio ref="scene-audio" :src="`${publicPath}scenes/john-austin/audio-charlie-navajo.mp3`" />
  </div>
</template>

<script>
import SceneDialogue from "../SceneDialogue.vue"
import Template from "./Template.vue"
import {TimelineLite, TweenMax, Elastic} from "gsap"

export default {
  data: () => ({
    publicPath: process.env.BASE_URL,
    canvasWidth: 4175,
    canvasHeight: 3006,
  }),
  props: ["slide"],
  extends: Template,
  mounted() {
    const { scene, sun, sky, d1, d2 } = this.$refs
    TweenMax.set(scene, {opacity: 0})
    TweenMax.set(d1.$el, {opacity: 0})
    TweenMax.set(d2.$el, {opacity: 0})
    // this.tl = new TimelineLite({paused: true})
    this.tl.add(TweenMax.to(scene, 2, {opacity: 1}))
    this.tl.add(TweenMax.to("#hue1feColorMatrix", 2, {attr: {values: 100}}), "-=1")
    this.tl.add(TweenMax.to(sun, 2, {y: 200, ease: Elastic.easeInOut.config(1, 1)}), "-=2")
    this.tl.add(TweenMax.to(d1.$el, 1, {opacity: 1}), "-=1")
    this.tl.add(TweenMax.to(d2.$el, 1, {opacity: 1}))
  },
  methods: {
    enter() { this.tl.play() }
  },
  components: {
    SceneDialogue,
  },
}
</script>

<style lang="scss" scoped>
</style>
